<script>
  import {Component, Prop, Vue} from "vue-property-decorator";

  @Component({
    components: {
      name: 'grid-table'
    }
  })

  export default class GridTable extends Vue {
    @Prop({
      type: Array, default: () => []
    }) dataList;
    @Prop({
      type: Array, default: () => []
    }) columns;
    @Prop({
      type: Object, default: () => ({
        gridColumnEnd: `span 1`,
        gridRowEnd: `span 1`,
      })
    }) cellStyle;

    get gridStyle() {
      const length = this.columns.length
      return {
        // 'grid-template-columns': `repeat(4, 1fr) 150px 1fr 150px repeat(3, 1fr)`
        'grid-template-columns': `repeat(${length},1fr)`,
      }
    }

    mounted() {
    }

    render(h) {
      const {columns, dataList, gridStyle, cellStyle} = this
      let center_vertical = {
        display: 'flex', 
        'justify-content': 'center', 
        'align-items': 'center'
      }
      return (
        <div>
          <div class="print-content-box">
            <div class="print-table-head1" style={gridStyle}>
              {
                columns.map(item =>
                  <div keys={item.label} style={{...item.style, ...center_vertical}}>{item.label}</div>
                )
              }
            </div>
            <div>
              {
                dataList.map(row => {
                    return row.render ? row.render(h) :
                      <div class="print-table-content" style={gridStyle} key={row.id}>
                        {
                          columns.map(col => {
                              return <div key={col.property} style={{...cellStyle,...row?.style, ...center_vertical}}>
                                {row[col.property]}
                              </div>
                            }
                          )
                        }
                      </div>
                  }
                )
              }
            </div>
          </div>
        </div>

      );
    }
  }
</script>
<style scoped lang="scss">
  .print-content-box {
    border-bottom: 1px solid;
    border-left: 1px solid;
    font-family: SimSun;
  }

  .print-table-head1 {
    display: grid;
    /*grid-template-columns: repeat(4, 1fr) 150px 1fr 150px repeat(3, 1fr);*/
    grid-template-rows: minmax(18px, 1fr);
    grid-column-gap: 0;
    grid-row-gap: 0;
  }

  .print-table-content {
    display: grid;
    grid-template-rows: minmax(24px, 1fr);
    grid-column-gap: 0;
    grid-row-gap: 0;
    box-sizing: border-box;
  }

  .print-table-head1 > div {
    font-size: 12px;
    border: 1px solid;
    border-left: none;
    border-bottom: none;
    line-height: normal;
    text-align: center;
    /*word-break: break-all;*/
    word-break:break-word;
  }

  .print-table-content > div {
    border: 1px solid;
    border-left: none;
    border-bottom: none;
    font-size: 12px;
    word-break: break-word;
    text-align: center;
    line-height: 14px;
  }

</style>
